

export default function vatCheck (selector) {
  const fields = document.querySelectorAll(selector);

  fields
    .forEach(field => field.addEventListener('change', () => {
      field.value = field.value
        .replace(/\.|\s/g, '')
        .toUpperCase();
    }));
}
